import { render, staticRenderFns } from "./FragmentVideo.vue?vue&type=template&id=38fddee8"
import script from "./FragmentVideo.vue?vue&type=script&lang=ts"
export * from "./FragmentVideo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports